package com.xtream.ui.ui.widget
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PlainTooltip
import androidx.compose.material3.Text
import androidx.compose.material3.TooltipAnchorPosition
import androidx.compose.material3.TooltipBox
import androidx.compose.material3.TooltipDefaults
import androidx.compose.material3.rememberTooltipState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TvToolTipSupportButton(
    modifier: Modifier = Modifier,
    plainTooltipText: String,
    icon: ImageVector,
    focusRequester: FocusRequester? = null,
    onClick: () -> Unit = {}
) {
    // 🚀 1. Set up the pipeline to track focus state automatically via interactions
    val interactionSource = remember { MutableInteractionSource() }
    val isFocused by interactionSource.collectIsFocusedAsState()

    val tooltipState = rememberTooltipState(isPersistent = true)

    // 🚀 2. Automatically sync your Lottie or Leanback tooltips with the focus pipeline state
    LaunchedEffect(isFocused) {
        if (isFocused) {
            tooltipState.show()
        } else {
            tooltipState.dismiss()
        }
    }

    val animatedScale by animateFloatAsState(
        targetValue = if (isFocused) 1.01f else 1.0f,
        label = "TvButtonScale"
    )

    val buttonModifier = if (focusRequester != null) {
        modifier.focusRequester(focusRequester)
    } else {
        modifier
    }

    TooltipBox(
        positionProvider =  TooltipDefaults.rememberTooltipPositionProvider(
            TooltipAnchorPosition.Below,
            4.dp
        ),
        tooltip = {
            PlainTooltip(
                containerColor = MaterialTheme.colorScheme.background,
                contentColor = MaterialTheme.colorScheme.onBackground,
            ) {
                Text(plainTooltipText)
            }
        },
        state = tooltipState
    ) {
        IconButton(
            // 🚀 3. Set the focused colors via the interaction state values
            colors = IconButtonDefaults.iconButtonColors(
                containerColor = if (isFocused) MaterialTheme.colorScheme.onSurface else Color.Transparent,
                contentColor = if (isFocused) MaterialTheme.colorScheme.background else MaterialTheme.colorScheme.onBackground,
            ),
            interactionSource = interactionSource, // 🚀 4. Pass the source to capture inputs
            modifier = buttonModifier.scale(animatedScale),
            onClick = onClick
        ) {
            Icon(
                imageVector = icon,
                contentDescription = plainTooltipText,
                // Keeps the icon color synced with the container's content state variations
                tint = if (isFocused) MaterialTheme.colorScheme.background else MaterialTheme.colorScheme.onBackground
            )
        }
    }
}